import React from 'react';
import { Link } from 'react-router-dom';
import './Service_Page.css';

const Service_Page = ({ services }) => {
  if (!services || services.length === 0) {
    return (
      <div className="no-services">
        <p>No services available.</p>
      </div>
    );
  }

  return (
    <div className="services-wrapper">
      {/* What We Do Heading */}
      <div className="services-intro">
        <h2 className="services-intro-title">What We Do</h2>
        <p className="services-intro-text">
          We provide comprehensive electrical solutions tailored to your needs. 
          From installations to repairs, our expert team delivers quality service 
          for residential, commercial, and industrial clients.
        </p>
      </div>

      {/* Services Grid */}
      <div className="services-grid">
        {services.map((service) => (
          <Link to={`/services/${service.slug}`} className="service-card" key={service.id}>
            <div className="service-image">
              <img src={process.env.PUBLIC_URL + service.image} alt={service.name} />
            </div>
            <div className="service-info">
              <h4 className="service-heading">{service.hero?.heading}</h4>
              <h3>{service.name}</h3>
              <p>{service.hero?.subheading}</p>
              <span className="service-btn">{service.buttonText}</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Service_Page;
